import React from 'react';

const Step2Infos = (props) => {
    return (
        <div className="slc-wizard-infos-step slc-wizard-infos-step-2">
        Indica la potenza dell’impianto fotovoltaico esistente.<br />
        Se tra le opzioni non compare l'esatta potenza del tuo impianto fotovoltaico non preoccuparti!<br />
        Indica la potenza che più si avvicina a quella del tuo impianto.<br />
        Questo dato serve a calcolare la capacità di accumulo della tua batteria.
        </div>
    );
}

export default Step2Infos;